import Vue from 'vue'
import VueRouter from 'vue-router'
import Profile from '@/assets/profile/Profile.js'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: { name: 'explore' }
  },
  //Explore siden
  {
    path: '/explore',
    name: 'explore',
    component: () => import('../views/Explore.vue')
  },
  //Forslags siden
  {
    path: '/recommended',
    name: 'recommended',
    component: () => import('../views/Recommended.vue')
  },
  //A-Å siden
  {
    path: '/alphabetic/:letter?',
    name: 'alphabetic',
    props: true,
    component: () => import('../views/Alphabetic.vue')
  },
  //Ruteplanlægger
  {
    //path: '/directions/:urlParams?',
    path: '/directions/:action?/:params?',
    name: 'directions',
    props: true,
    component: () => import('../views/Directions.vue')
  },
  //Gruppe side
  {
    path: '/group/:groupId/:startup?',
    name: 'group',
    props: true,
    component: () => import('../views/GroupPage.vue')
  },
  //Tema side - Fallback for gamle links
  {
    path: '/theme/:groupId/:startup?',
    name: 'group',
    props: true,
    component: () => import('../views/GroupPage.vue')
  },
  //Tag side
  {
    path: '/tag/:tagId/:startup?',
    name: 'tag',
    props: true,
    component: () => import('../views/TagPage.vue'),
  },
  //Sted side
  {
    path: '/tag/:tagId/place/:placeId/:startup?',
    name: 'place',
    props: true,
    component: () => import('../views/PlacePage.vue'),
  },
  //Nyheder
  // {
  //   path: '/news',
  //   name: 'news',
  //   component: () => import('../views/NewsPage.vue')
  // },
  //Søge siden
  {
    path: '/search',
    name: 'search',
    component: () => import('../views/Search.vue')
  },
  //Hjælp siden
  {
    path: '/help',
    name: 'help',
    component: () => import('../views/Help.vue')
  },
  //Om siden
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/About.vue')
  },
  //Kontakt
  {
    path: '/contact/:action?/:id?/:type?',
    name: 'contact',
    props: true,
    component: () => import('../views/Contact.vue')
  },
  //Profil
  // {
  //   path: '/profile/:activePage?',
  //   name: 'profile',
  //   props: true,
  //   component: () => import('../views/ProfilePage.vue')
  // },
  //Brugergruppe på kort
  {
    path: '/usergroup/:userGroupId?',
    name: 'usergroup',
    props: true,
    component: () => import('../views/UserGroupPage.vue')
  },
  //Login
  // {
  //   path: '/login/:action?',
  //   name: 'login',
  //   props: true,
  //   component: () => import('../views/LoginPage.vue')
  // },
  // //Register
  // {
  //   path: '/register',
  //   name: 'register',
  //   component: () => import('../views/RegisterPage.vue')
  // },
  //Iframe guide
  {
    path: '/iframeguide/:action?',
    name: 'iframeguide',
    props: true,
    component: () => import('../views/IframeGuide.vue')
  },
  {
    path: '/notfound',
    name: 'notfound',
    component: () => import('../views/MissingPage.vue')
  },
  //Privatlivspolitik
  {
    path: '/privatlivspolitik',
    name: 'privatlivspolitik',
    component: () => import('../views/PrivacyPolicy.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  /*console.log(to);
  console.log(from);
  console.log(next);*/
  //Check if mobile menu is open. Check if elem exist or error on app startup
  var content = document.getElementById('content');
  if(content != null) {
    if(content.classList.contains('menu-open')) {
      document.getElementById('content').classList.remove('menu-open');
      document.getElementById('mobile-menu').classList.remove('menu-open');
      setTimeout(() => {
        document.getElementById('mobile-menu').classList.add('hidden');
      }, 200);
    }
  }

  //Timeout så login stuff kan nå at kører ved refresh på profile sider. Ellers ryger brugeren til login
  setTimeout(() => {
    //Fjern scroll indikator på directions og bruger samling kort
    var scrollIndicator = document.getElementById('scroll-indicator');
    if(scrollIndicator != null) {
      if(to.name == 'directions' || to.name == 'usergroup') {
        scrollIndicator.classList.add('hidden');
      }
      else {
        scrollIndicator.classList.remove('hidden');
      }
    }
    if(to.name == 'profile' && !Profile.loggedIn) next({ name: 'login' })
    else next();
  }, 250);
})

export default router;
